import { PortalBrand } from '../PortalBrand'

export const FestivalLoading = () => {
  return (
    <div className={'flex h-full w-full items-center justify-center bg-sand'}>
      <PortalBrand />
    </div>
  )
}
